import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { EnvConfigService } from './app/modules/core/services/config-handler/config-handler.service';

if (environment.production) {
  enableProdMode();
}

EnvConfigService.loadConfig().then(() => {
  return platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
});
